import request from "@/utils/request";

export const getToolkits = (params) => {
  return request({
    url: "/toolkit/",
    method: "get",
    params,
  });
};

export const getToolkitId = (id) => {
  return request({
    url: `/toolkit/${id}/`,
    method: "get",
  });
};

export const postToolkit = (data) => {
  data.image = data.image.path;
  return request({
    url: "/toolkit/",
    method: "post",
    data,
  });
};

export const putToolkit = (id, data) => {
  data.image = typeof data.image === "object" ? data.image.path : data.image;
  return request({
    url: `/toolkit/${id}/`,
    method: "put",
    data,
  });
};

export const deleteToolkit = (id) => {
  return request({
    url: `/toolkit/${id}/`,
    method: "delete",
  });
};
